function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.344 36.459c-.197 3.695 2.388 6.162 5.334 6.162.246 0 .49-.017.734-.051a6.282 6.282 0 009.432.546 5.334 5.334 0 009.28-4.545 6.282 6.282 0 00-6.235-10.57 6.283 6.283 0 00-5.15-2.686h-.002 0a6.282 6.282 0 00-4.602 2.007 5.334 5.334 0 00-1.086-.111c-1.81 0-4.29 1.016-4.787 2.694",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.34 32.364c7.24 1.034 5.378 10.343-1.862 6.206"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.863 23.507a4.654 4.654 0 01-3.103-1.797 3.59 3.59 0 01-2.348.547 3.59 3.59 0 01-3.157-3.977 3.59 3.59 0 013.976-3.157 3.59 3.59 0 011.741.692 4.654 4.654 0 014.023-1.547 4.654 4.654 0 013.658 2.6 3.59 3.59 0 012.136-.418 3.59 3.59 0 013.158 3.977 3.59 3.59 0 01-3.977 3.157 3.59 3.59 0 01-2.351-1.274 4.654 4.654 0 01-3.686 1.205 4.654 4.654 0 01-.07-.008z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.645 22.404s-6.927 13.549 3.49 15.125c13.725 2.075 9.308-14.31 9.308-14.31M26.792 20.986c3.103 0 3.94 1.635 5.171 4.137-2.333.06-4.601.45-7.24-1.034M8.175 18.918c-2.806-.908-4.47.66-6.206 2.069 3.144 3.075 6.415 2.101 9.676 1.417M26.792 42.707l2.069 8.274h5.171v-5.688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.689 40.845l2.069 9.102h3.103M46.444 42.5l-2.069 8.481h-4.137v-6.206"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.17 43.741v6.206h2.069"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.829,
  cy: 26.675,
  r: 0.517,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.035,
  cy: 26.675,
  r: 0.517,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.38 34.432h3.103"
})));

var SvgSheep = function SvgSheep(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSheep, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sheep.1bb3b337.svg";
export { ForwardRef as ReactComponent };